import {Organization, OrganizationCategory} from '@catalyst-zero/company-schema/types/Organization'

const hasCategory = (categoryName: OrganizationCategory, organization?: Organization): boolean =>
  organization?.organizationCategories?.includes(categoryName) || false

export const hasCompanyCategory = (organization?: Organization): boolean => hasCategory('company', organization)

export const hasProductsCategory = (organization?: Organization): boolean => hasCategory('products', organization)

export const hasAssetsCategory = (organization?: Organization): boolean =>
  Boolean(window.czConfig.ENABLE_ADAT) && hasCategory('assets', organization)
